// eslint-disable-next-line jira/filename-case
import React from 'react';
import { SidebarBoundary } from '@jira/navigation-apps__sidebar-common/src/async.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { Sidebar as GlobalAlertsSidebarType } from './ui/index.tsx';

export const LazyGlobalAlertsSidebar: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof GlobalAlertsSidebarType
>(
	() =>
		import(/* webpackChunkName: "async-sidebar-global-alerts" */ './index.tsx').then(
			(bundle) => bundle,
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

export const AsyncSidebarEocGlobalAlerts = (): React.JSX.Element => (
	<SidebarBoundary id="eocGlobalAlerts">
		<LazyGlobalAlertsSidebar />
	</SidebarBoundary>
);
